import React from "react";
import { Link } from "react-router-dom";

const LinkCard = (props: any) => {
  return (
    <Link to={props?.href} className="block">
      <div className="w-full flex justify-center gap-x-6 uppercase items-center h-[50px] border-[1px] border-primary mb-8 text-primary">
        {props?.icon}
        {props?.label}
      </div>
    </Link>
  );
};

export default LinkCard;
